import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {
  PublicClientApplication,
  EventType
} from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { UserProvider } from './context/UserContext'; 
import { GoogleOAuthProvider } from '@react-oauth/google';
import { TabProvider } from './context/TabContext';

const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
const microsoftClientId = process.env.REACT_APP_MICROSOFT_CLIENT_ID;
const microsoftAuthority = process.env.REACT_APP_MICROSOFT_AUTHORITY;
const microsoftRedirectUri = process.env.REACT_APP_MICROSOFT_REDIRECT_URI;
const msalConfig = {
  auth: {
    clientId: microsoftClientId,
    authority: microsoftAuthority,
    redirectUri: microsoftRedirectUri,
    postLogoutRedirectUri: "/",
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

const pca = new PublicClientApplication(msalConfig);
pca.addEventCallback((event) => {
  if (
    event.eventType === EventType.LOGIN_SUCCESS &&
    isAuthenticationResult(event.payload)
  ) {
    pca.setActiveAccount(event.payload.account);
  }
});

function isAuthenticationResult(payload) {
  return (
    typeof payload === "object" &&
    "account" in payload &&
    "idToken" in payload &&
    "accessToken" in payload
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <MsalProvider instance={pca}>
    <GoogleOAuthProvider clientId={googleClientId}>
      <UserProvider>
        <TabProvider>
          <App/>
        </TabProvider>
      </UserProvider>
    </GoogleOAuthProvider>
  </MsalProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
